module.exports = __webpack_public_path__ + "static/img/environment_06_h5.6d51bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_06_h5.png
// module id = l85y
// module chunks = 34